import { openBiDirectionalChannel } from '../utils';
import { OPEN_FORM } from '../constants';
var openForm = (params, formConfig) => {
  if (formConfig && formConfig.onSuccess) {
    // functions cannot be passed in postMessage and hence making it undefined.
    // success callBack will be invoked in callBack Function.
    formConfig.onSuccess = undefined;
  }
  openBiDirectionalChannel(params, {
    type: OPEN_FORM,
    payload: formConfig
  });
};
export default openForm;